<ul ngbNav #nav="ngbNav" class="nav-tabs">
  <li ngbNavItem>
    <a ngbNavLink>Search ({{gridCount}})</a>

    <ng-template ngbNavContent>
      <rl-entity-search [dataSource]="dataSource" [searchOptions]="searchOptions" target="_blank"
        [stretchHeight]="true" [alwaysShowHeader]="true">
      </rl-entity-search>
    </ng-template>
  </li>
  <li ngbNavItem>
    <a ngbNavLink>Input IDs</a>

    <ng-template ngbNavContent>
      <rl-input-list [childCharTypeId]="assocCharTypeId" [charTypeId]="charTypeId"
        [matchesParentQuery]="matchesParentQuery" (onValidate)="updateValidated($event)"
      [includeParentRecordId]="isTablesOrRights" [isAssociatingChild]="isAssociatingChild"
				[parentRecordId]="parentRecordId" [parentCharTypeId]="parentCharTypeId"></rl-input-list>
    </ng-template>
  </li>
  @if (assocCharTypeId === 1) {
    <li ngbNavItem>
      <a ngbNavLink data-cy="WorksheetTab">Worksheets</a>
      <ng-template ngbNavContent>
        <rl-clipboard-selection-grid [parentCharTypeId]="charTypeId" [parentTemplateId]="parentTemplateId"
        (onWorksheetSelected)="worksheetSelected($event)"></rl-clipboard-selection-grid>
      </ng-template>
    </li>
  }
</ul>
<div [ngbNavOutlet]="nav"></div>
<ng-content></ng-content>
@if (dataSource) {
  <rl-association-chips [charTypeId]="assocCharTypeId" [dataSource]="dataSource">
  </rl-association-chips>
}